{
  "close": "Luk",
  "notifications": "{count, plural, one {# besked} other {# beskeder}}."
}
